import React from 'react';
import { FormControlLabel, FormControlLabelClassKey } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import TableDatePicker from 'ui/TableInputs/TableDatePicker/TableDatePicker';
import { Select, SelectItem } from 'ui/Input';
import FileField from 'ui/Input/UploadArea/FileField';
import { TransferFrequencyList } from 'utils/constants';
import Switch from 'ui/Switch/Switch';
import { IAccount } from 'store/accounts.model';
import { IFormValues } from './BulkFileUpload.model';

const renderSourceAccountField = (accounts: IAccount[], submitting: boolean) => (
  <Select name="sourceAccount" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

export const renderScheduleControl = (
  toggleScheduleTransfer: () => void,
  toggleSchedule: boolean | null,
  classes: Partial<ClassNameMap<FormControlLabelClassKey>> | undefined,
) => (
  <FormControlLabel
    control={<Switch />}
    checked={toggleSchedule === null ? false : toggleSchedule}
    onChange={toggleScheduleTransfer}
    label="Schedule transfer for later"
    labelPlacement="end"
    classes={classes}
    name="scheduleTransfer"
  />
);

export const renderScheduleForm = (
  submitting: boolean,
  dateFilterChange: (name: string, value?: string | null | undefined) => void,
  handleClearDateInput: (name: string, value?: string | null | undefined) => void,
  values: IFormValues,
) => (
  <>
    <Select name="frequency" label="Frequency" disabled={submitting}>
      {TransferFrequencyList.map(({ label, value }) => (
        <SelectItem value={value} key={value}>
          {label}
        </SelectItem>
      ))}
    </Select>
    <TableDatePicker
      name="specialDate"
      label="Special Date"
      onChange={dateFilterChange}
      onClickClear={handleClearDateInput}
      disabled={submitting || values.frequency !== 'specialDate'}
    />
  </>
);

export const renderTransferFieldsFrom = (accounts: IAccount[], submitting: boolean) => (
  <>{renderSourceAccountField(accounts, submitting)}</>
);

export const renderBulkTransferUpload = (submitting: boolean) => (
  <>
    <FileField name="files" disabled={submitting} />
  </>
);
